import {
  QBO_REQUEST, QBO_STATUS_SUCCESS, QBO_CUSTOMERS_SUCCESS,
  QBO_CUSTOMER_SEARCH_SUCCESS, QBO_CUSTOMER_DETAIL_SUCCESS,
  QBO_SYNC_SUCCESS, QBO_INVOICES_SUCCESS, QBO_ITEMS_SUCCESS,
  QBO_DISCONNECT_SUCCESS, QBO_FLAG_OFF, QBO_REQUEST_FAILED,
} from '../constant';

const initialState = {
  loading: false,
  error: '',
  // 연결 상태
  connected: false,
  companyName: '',
  realmId: '',
  lastSyncAt: null,
  // 고객 데이터
  customers: [],
  qboCustomersMeta: null,
  searchResults: [],
  selectedCustomer: null,
  // 동기화 결과
  syncResult: null,
  // 인보이스
  invoices: [],
  // 아이템
  items: [],
  // 플래그
  syncSuccess: false,
  disconnected: false,
};

export const qboReducer = (state = initialState, action) => {
  switch (action.type) {
    case QBO_REQUEST:
      return { ...state, loading: true, error: '' };

    case QBO_STATUS_SUCCESS:
      return {
        ...state, loading: false,
        connected: action.payload.connected,
        companyName: action.payload.companyName || '',
        realmId: action.payload.realmId || '',
        lastSyncAt: action.payload.lastSyncAt,
      };

    case QBO_CUSTOMERS_SUCCESS:
      return {
        ...state,
        loading: false,
        customers: action.payload.customers || [],
        qboCustomersMeta: {
          total: action.payload.total,
          all: action.payload.all,
          pagesFetched: action.payload.pagesFetched,
        },
      };

    case QBO_CUSTOMER_SEARCH_SUCCESS:
      return { ...state, loading: false, searchResults: action.payload || [] };

    case QBO_CUSTOMER_DETAIL_SUCCESS:
      return { ...state, loading: false, selectedCustomer: action.payload };

    case QBO_SYNC_SUCCESS:
      return { ...state, loading: false, syncResult: action.payload, syncSuccess: true };

    case QBO_INVOICES_SUCCESS:
      return { ...state, loading: false, invoices: action.payload.invoices || [] };

    case QBO_ITEMS_SUCCESS:
      return { ...state, loading: false, items: action.payload.items || [] };

    case QBO_DISCONNECT_SUCCESS:
      return { ...initialState, disconnected: true };

    case QBO_FLAG_OFF:
      return { ...state, syncSuccess: false, disconnected: false, error: '' };

    case QBO_REQUEST_FAILED:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
